module.exports = {
  language: {
    name: 'EN',
    url: '/static/images/a2.png',
    tophtml: '<h1>"&nbsp;&nbsp;我们<br />&nbsp; &nbsp;为企业和消费者提供<br />&nbsp; &nbsp;有价值的平台 &nbsp;"</h1><h3>&nbsp; &nbsp; &nbsp;—— &nbsp;南京斯图加特联展有限公司</h3>',
    tophtml1: "我们致力于为企业和消费者提供有价值的贸易平台",
    tophtml2: "—— 南京斯图加特联合展览有限公司",
    placeholder: "选择日期",
    placeholder2: '请选择',
    lang: 'cs',
    errmsg1: '获取信息失败！',
    errmsg2: '网络错误！',
    formmsg1: '信息填写不全,请完善信息!',
    partners: '合作伙伴',
    education: [
      {
        value: "1",
        label: "大专",
      },
      {
        value: "2",
        label: "本科",
      },
      {
        value: "3",
        label: "研究生",
      },
      {
        value: 4,
        label: "博士"
      }
    ],
    exhibitionname: '展会概况',
    exhibitiontitle: '展会',
    exhibitonst1: [{
      id: 1,
      name: '教育与培训'
    }, {
      id: 2,
      name: '创新'
    }, {
      id: 3,
      name: '工业解决方案'
    },
    {
      id: 4,
      name: '生活方式与休闲'
    }
    ],
    exhibitonst2: [
      {
        id: 4,
        name: '生活方式与休闲'
      },
      {
        id: 3,
        name: '工业解决方案'
      },
      {
        id: 5,
        name: '商业与教育'
      }
    ],
    demondtitle: "观展需求",
    demond: [{
      id: 1,
      name: '咨询'
    },
    {
      id: 2,
      name: '我要观展'
    },
    {
      id: 3,
      name: '我要邀请函'
    },
    {
      id: 4,
      name: '我要门票+邀请函'
    }
    ],
    exhibitionhome: '请在填写表格后，将以上信息以word格式发送至公司邮箱：marketing@messenanjing.cn',
    exhibitionglob: '请在填写表格后，将以上信息以word格式发送至公司邮箱：gina.ji@messenanjing.cn',
    revsertitle: '南京国际博览中心欢迎您',
    revserbtn: '展馆预定',
    mediatitle: "媒体中心",
    mediavideo: "亮点视频",
    medianews: "公司新闻",
    moretext: "更多",
    jointext: '加入我们',
    joinbtntext: '加入',
    btcontact: '联系我们',
    jontitle: "招募",
    pagetextup: '上一页:',
    pagetextdown: '下一页:',
    joinus1: '网上求职',
    joinus2: '如果您想联系我们，请留下电话号码并与您联系',
    joinusform: {
      name: '姓名',
      gender: '性别',
      gender1: '男',
      gender2: '女',
      databirth: '出生日期',
      phone: '手机号',
      email: '邮箱',
      education: '学历',
      addresstitle: '联系地址',
      province: '省',
      city: '市',
      area: '区',
      detailaddress: '请输入详细地址',
      jobsearch: '教育经历',
      lastjob: '工作经历',
      submitbtn: '提交'
    },
    joinemail: "请在填写表格后，将个人简历作为附件发送至公司招聘邮箱:hr@messenanjing.cn",
    exhform: {
      companyname: '公司名称',
      address1: '国家/地区',
      address2: '地址',
      name: '姓名',
      gender1: '男',
      gender2: '女',
      jobtitle: '职位名称',
      tel: '电话',
      mobilephone: '移动电话',
      email: '邮箱',
      interstedex: '感兴趣的展览',
      pinfang: '所需展位面积平方米（填写)',
      countrytext: "国家/城市"
    },
    jonbtn: '工作职位说明',
    applybtn: '立即申请',
    tableth: {
      th1: '展会',
      th2: '时间',
      th3: '地点',
      th4: '官微及官网',
      th5: '观众登记',
      th6: '展商登记'
    },
    timename: '日期',
    tjsuccess: '提交成功，请耐心等待',
    keytitle: '首页'
  },
  navbar: {
    home: '首页',
  },

}


// WEBPACK FOOTER //
// ./src/i18n/config/zh.js